module.exports = __webpack_public_path__ + "img/logo-header-mobile.739759da.png";